const delete_dialog = {
	confirmation:
		"For confirmation, please enter the name of your VPS <strong>{{name}}</strong> in the input field below.",
	running: {
		description:
			"A VPS cannot be deleted while its status is still active. Please stop the VPS before attempting deletion.",
		title: "Your VPS is still active!",
	},
	title: "Delete VPS",
	warning: "Deleting a VPS is permanent and cannot be undone.",
};

export default delete_dialog;
